export function isNullOrUndefined(obj: unknown): obj is null | undefined {
  return obj === null || obj === undefined;
}

export function isNullOrEmptyString(obj: string): boolean {
  return !obj || !obj.length;
}

export function startsWithString(s: string, prefix: string): boolean {
  if (!prefix.length) {
    return true;
  }
  if (prefix.length > s.length) {
    return false;
  }
  return s.substr(0, prefix.length) === prefix;
}

export function endsWithString(s: string, suffix: string): boolean {
  if (!suffix.length) {
    return true;
  }
  if (suffix.length > s.length) {
    return false;
  }
  return s.substr(s.length - suffix.length) === suffix;
}

export function isValue(obj: unknown): boolean {
  return obj !== null && obj !== undefined;
}

export function compareStrings(s1: string, s2: string, ignoreCase: boolean): number {
  if (!isValue(s1)) return isValue(s2) ? -1 : 0;
  if (!isValue(s2)) return 1;

  if (ignoreCase) {
    if (s1) {
      s1 = s1.toUpperCase();
    }
    if (s2) {
      s2 = s2.toUpperCase();
    }
  }
  s1 = s1 || '';
  s2 = s2 || '';

  if (s1 === s2) {
    return 0;
  }
  if (s1 < s2) {
    return -1;
  }
  return 1;
}
